import React from 'react';
import {duckify, singleDuck, dependentDuck, filterDuck, currentUser, currentCustomer} from "utils/duckify";
import Placeholder from 'components/Placeholder';
import FA from "utils/FA";
import {renderedSnippet} from "ducks/webSnippets";
import PropTypes from 'prop-types';
import {getMetaContent} from "utils/urls";
import {titleize} from "../../../utils/strings";
import PaymentDetailsInput from "../detailInputs/PaymentDetailsInput";
import {paymentTypes, paymentMethodDisplayName, submitButtonText} from "components/payments/paymentInputs/PaymentSelector";

/**
 * Represents a manual payment method (check, cash, or custom).
 * This does not create an Order, and can't be used to create a PaymentProfile.  Submitting simply redirects the user to
 * an entity-specific controller that handles manual payments for that type of entity.
 *
 */
class ManualPaymentInput extends React.Component {
  static propTypes = {
    manualPaymentUrl: PropTypes.string.isRequired
  };

  constructor(){
    super();

    this.state = {
      submitting: false
    }
  }

  handleSubmit() {
    this.setState({submitting: true});

    return true;
  }

  render() {
    const {
      allDucksReady,
      showButtonText,
      explanation,
      paymentDetails,
      payment_method,
      manualPaymentUrl,
      currentCustomer
    } = this.props;

    const {submitting} = this.state;

    const disabled = this.props.disabled || !paymentDetails.valid;

    return <Placeholder.loading ready={allDucksReady} content={() =>
      <div>
        {
          explanation && <div className={'custom-payment-explanation'} dangerouslySetInnerHTML={{__html: explanation}}/>
        }

        <form method={'POST'} action={manualPaymentUrl} onSubmit={()=>this.handleSubmit()}>
          <input type={'hidden'} name={'payment_method'} value={payment_method}/>
          <input type={'hidden'} name={'authenticity_token'} value={getMetaContent('csrf-token')}/>

          <fieldset className={'payment-manual-input'}>
            <PaymentDetailsInput
              onChange={this.props.paymentDetailsChanged}
              customer={currentCustomer}
              disabled={submitting}
            />
          </fieldset>

          {submitting ?
            <button className={'btn btn-primary'} type={'button'} disabled>
              <FA name={'spinner'} spin nbsp/>
              Submitting...
            </button>
            :
            <button className={'btn btn-primary'}
                    disabled={disabled}
            >
              {showButtonText}
            </button>
          }
        </form>
      </div>
    }/>;
  }
}

const mapDucksToPropsCheck = (ownProps) => ({
  currentCustomer,
  explanation: ownProps.checkExplanation && renderedSnippet(ownProps.checkExplanation)
});

const mapStateToPropsCheck = (state, ownProps) => {
  const {allDucksReady, currentCustomer} = ownProps;

  if(!allDucksReady){
    return {};
  }

  return {
    showButtonText: submitButtonText(currentCustomer, paymentTypes.CHECK),
    payment_method: paymentTypes.CHECK,
    explanation: ownProps.explanation && ownProps.explanation.body
  };
};

const mapDucksToPropsCustom = (ownProps) => ({
  currentCustomer,
  explanation: renderedSnippet('custom_payment_instructions')
});

const mapStateToPropsCustom = (state, ownProps) => {
  const {allDucksReady, currentCustomer} = ownProps;

  if(!allDucksReady){
    return {}
  }

  return {
    showButtonText: submitButtonText(currentCustomer, paymentTypes.CUSTOM),
    explanation: ownProps.explanation && ownProps.explanation.body,
    payment_method: paymentTypes.CUSTOM
  };
};

export const CheckInput = duckify(mapDucksToPropsCheck, mapStateToPropsCheck)(ManualPaymentInput);
export const CustomPaymentInput = duckify(mapDucksToPropsCustom, mapStateToPropsCustom)(ManualPaymentInput);
